(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wi-fg-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const resultsUL = document.querySelector('results-list ul[data-testid="product-grid"]')
      const theLis = resultsUL.querySelectorAll('li');
      if (theLis) {
        for (anItem of theLis) {
          var index = anItem.dataset.promoCard;
          if (index) {
            //console.log(`found one, moving it to position ${index}`);
            if (index > resultsUL.childNodes.length) {
              index = resultsUL.childNodes.length;
            }
            if (index > 1) {
              resultsUL.insertBefore(anItem, theLis[index]);
            }
            anItem.removeAttribute('hidden');
          }
        }
      }
    },
    { once: true }
  );


  } catch(e) { console.error(e); }
})();
})();
